/** Damage percentages apply to the combined typed fragments before flat
 * reductions. Round half away from zero, as the shared damage total requires. */
export function applyDamagePercentage(total: number, percentage: number): { total: number; change: number } {
  const value = total * (1 + percentage / 100);
  const next = value < 0 ? -Math.round(-value) : Math.round(value);
  return { total: next, change: next - total };
}
